import _ from 'lodash'
import moment from 'moment'

export default navbarDashboard

/** @ngInject */
function navbarDashboard($state, $uibModal, ApiService, ContractStatusLabel) {
    return ({
        restrict: 'E',
        template: require('./navbarDashboard.jade')(),
        link: ($scope) => {
            $scope.termsViewState = _.get(ContractStatusLabel, [$scope.userInfo.contractSelected.status, 'termsView'], ContractStatusLabel.unknown.termsView)
            $scope.canDisplayPotBurn = () => {
                const potBurnConfirmed = JSON.parse(sessionStorage.getItem('potBurnConfirmed'))
                return $scope.pot.real > 0 || (potBurnConfirmed && moment().isBefore(potBurnConfirmed.expire))
            }

            $scope.openChangePaymentDayModal = () => {
                $uibModal.open({
                    animation: true,
                    size: 'lg',
                    component: 'changePaymentDayModal',
                    resolve: {
                        paymentDayInfo(BillingAcc, ErrorCatcher) {
                            return BillingAcc.getPaymentDay().$promise.catch(ErrorCatcher.catchError)
                        },
                    },
                }).result.then((result) => {
                    if (result.isSubmitted) {
                        // Reload userInfo instead of reloading page (currently break transition & page animation)
                        ApiService.resetPromise('userInfo')
                        $state.go($state.current, { contractId: $scope.userInfo.contractSelected.id }, { reload: true })
                    }
                })
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/navbar/navbarDashboard.js